<script setup>
import { ref, defineProps, defineEmits } from "vue";
import SearchMagnifier from "@/components/shared/icons/SearchMagnifier.vue";
import ClearText from "@/components/shared/icons/ClearText.vue";

const props = defineProps({
  label: {
    type: String,
    default: "Find potential course matches",
  },
  placeholder: {
    type: String,
    default: "Enter a course description and/or title to start your search",
  },
});

const emit = defineEmits(["search"]);

const searchQuery = ref("");

const clearInput = () => {
  searchQuery.value = "";
};

const performSearch = () => {
  emit("search", searchQuery.value);
};
</script>

<template>
  <div class="flex flex-col p-5 rounded-lg bg-purple-50 border-l-8 border-purple-700">
    <label class="font-semibold pb-2 text-university-primary" for="search-input">
      {{ label }}
    </label>
    <div class="flex">
      <div class="relative flex-1 flex row border p-3 border-gray-300 bg-white rounded-md text-sm">
        <textarea
          id="paragraph-input"
          v-model="searchQuery"
          class="flex-1 w-full min-h-10 text-sm border-none outline-none rounded-md resize-none"
          aria-label="Course Search"
          :placeholder="placeholder"
          @keydown.enter.exact.prevent="performSearch"
        ></textarea>
        <button v-if="searchQuery" class="pr-2" aria-label="Clear search" @click="clearInput">
          <ClearText />
        </button>
        <button
          class="flex justify-center items-center py-3 px-5 mt-auto font-semibold uppercase text-white bg-university-secondary border-university-secondary"
          @click="performSearch"
        >
          <div class="inline-block py-1">
            <SearchMagnifier />
          </div>
          <span class="inline-block text-base">
            SEARCH
          </span>
        </button>
      </div>
    </div>
  </div>
</template>
